module.exports = __webpack_public_path__ + "img/appointmentConfirmationLeft.0acca287.png";